import { render } from "./QuickKeys.vue?vue&type=template&id=7867ebf8&scoped=true"
import script from "./QuickKeys.vue?vue&type=script&lang=js"
export * from "./QuickKeys.vue?vue&type=script&lang=js"

import "./QuickKeys.vue?vue&type=style&index=0&id=7867ebf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7867ebf8"]])

export default __exports__